import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

// https://fly.customer.io/workspaces/56354/pipelines/sources/14282
const sourceApiKey = '74229fee97672a2b4332';
// Workspace: People.Campaigns (138234)
const workspaceSiteId = '5b613177d192212670dc';

export const analytics =
  __CIO_ENV__ === 'production'
    ? AnalyticsBrowser.load(
        { writeKey: sourceApiKey },
        {
          integrations: {
            'Customer.io In-App Plugin': {
              siteId: workspaceSiteId,
              // @ts-expect-error - `integrations.events` is not properly typed,
              events: (event: CustomEvent) => {
                window.dispatchEvent(
                  new CustomEvent(event.type, {
                    detail: event.detail,
                  }),
                );
              },
            },
          },
        },
      )
    : undefined;
